/* ft-warenkorb.js (05.10.2026, Sitzung Webshop, Ladezeit der Produktseite): Skript aus snippets/ft-warenkorb ausgelagert (defer).
   Beschreibung, Regeln und Historie stehen weiter im Snippet. */
(function () {
  var KOPF = { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' };
  var FRIST_MS = 15000;

  function regel() {
    return window.ftPfandRegel || { VID: 0, RX: /^(TLN|TLG|TLNK|TLGK|TLNS|TLGS)-/i, EIGENSCHAFT: {} };
  }
  function reihe(auftrag) {
    return (typeof window.ftCartQueue === 'function') ? window.ftCartQueue(auftrag) : auftrag();
  }
  function pause(ms) { return new Promise(function (weiter) { setTimeout(weiter, ms); }); }
  function mitFrist(p, ms) {
    return new Promise(function (erfuellt, abgelehnt) {
      var t = setTimeout(function () { abgelehnt({ status: 0, fehler: 'Zeitüberschreitung' }); }, ms);
      p.then(function (w) { clearTimeout(t); erfuellt(w); }, function (f) { clearTimeout(t); abgelehnt(f); });
    });
  }
  /* Ein Aufruf mit Antworttext; Fehler als { status, fehler, warte } */
  function schicken(url, daten, methode) {
    var opt = { method: methode || 'POST', credentials: 'same-origin', headers: KOPF, cache: 'no-store' };
    if (daten) { opt.body = JSON.stringify(daten); }
    return mitFrist(fetch(url, opt).then(function (r) {
      return r.text().then(function (t) {
        var j = null;
        try { j = t ? JSON.parse(t) : null; } catch (e) { j = null; }
        if (r.ok && j) { return j; }
        var f = { status: r.status, fehler: (j && (j.description || j.message)) || ('HTTP ' + r.status) };
        if (r.ok && !j) { f.status = 429; f.fehler = 'Antwort ohne Daten'; }  /* Drossel liefert teils HTML mit 200 */
        var sek = parseFloat(r.headers.get('Retry-After'));
        if (sek > 0) { f.warte = Math.min(3000, Math.max(800, sek * 1000)); }
        throw f;
      });
    }, function () { throw { status: 0, fehler: 'Keine Verbindung' }; }), FRIST_MS);
  }
  /* Wiederholen, wo es sicher ist. nurAntwort = true (Einlegen mit /cart/add.js): nur wenn Shopify ausdrücklich abgelehnt hat
     (429, 5xx), denn dann wurde nichts eingelegt. Bei Zeitüberschreitung oder abgerissener Verbindung ist offen, ob Shopify
     schon eingelegt hat; ein zweiter Versuch könnte doppelt einlegen. Lesen und Mengen setzen (/cart.js, /cart/update.js)
     sind wiederholbar und werden auch dann wiederholt. */
  function einmalWiederholen(versuch, nurAntwort) {
    return versuch().then(null, function (f) {
      var s = f && f.status;
      if (s && s < 500 && s !== 429) { throw f; }
      if (nurAntwort && !s) { throw f; }
      return pause((f && f.warte) || 1500).then(versuch);
    });
  }
  function pflichtig(pos) {
    if (pos.pfand === true) { return true; }
    if (pos.pfand === false) { return false; }
    return regel().RX.test(String(pos.sku || ''));
  }

  /* Fehler an GA4 melden (siehe Kopf). Einwilligung wie in layout/theme.liquid: ft-consent-analytics „yes“ oder alter Wert
     „all“, höchstens ein Jahr alt; dazu Shopifys eigene Abfrage, falls sie geladen ist. Die Meldung darf den Warenkorb nie
     stören, darum alles in try. */
  var gemeldet = 0;
  function analyseErlaubt() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && typeof cp.analyticsProcessingAllowed === 'function' && cp.analyticsProcessingAllowed()) { return true; }
      var ts = parseInt(localStorage.getItem('ft-consent-ts') || '0', 10);
      if (ts && (Date.now() - ts) > 365 * 24 * 3600 * 1000) { return false; }
      return localStorage.getItem('ft-consent-analytics') === 'yes' || (localStorage.getItem('ft-consent') || '').toLowerCase() === 'all';
    } catch (e) { return false; }
  }
  window.ftKorbFehlerMelden = function (weg, d) {
    try {
      if (gemeldet >= 5 || typeof window.gtag !== 'function' || !analyseErlaubt()) { return; }
      gemeldet += 1;
      d = d || {};
      window.gtag('event', 'ft_korb_fehler', {
        weg: String(weg || 'unbekannt').slice(0, 40),
        status: parseInt(d.status, 10) || 0,
        fehler: String(d.fehler || '').slice(0, 100),
        seite: String(location.pathname || '').slice(0, 100),
        mit_pfand: d.mitPfand ? 1 : 0
      });
    } catch (e) { /* nie den Warenkorb stören */ }
  };

  window.ftInDenWarenkorb = function (positionen, optionen) {
    optionen = optionen || {};
    var R = regel();
    var liste = (positionen || []).map(function (p) {
      return { id: parseInt(p.id, 10), quantity: Math.max(1, parseInt(p.quantity, 10) || 1), sku: p.sku, pfand: p.pfand, properties: p.properties };
    }).filter(function (p) { return p.id > 0; });
    if (!liste.length) {
      window.ftKorbFehlerMelden(optionen.weg || 'einlegen', { status: 0, fehler: 'Kein Artikel gewählt' });
      return Promise.resolve({ ok: false, status: 0, fehler: 'Kein Artikel gewählt' });
    }
    var pfandMenge = liste.reduce(function (s, p) { return s + (pflichtig(p) ? p.quantity : 0); }, 0);
    var items = [];
    if (pfandMenge > 0 && R.VID) { items.push({ id: R.VID, quantity: pfandMenge, properties: R.EIGENSCHAFT }); }
    liste.slice().reverse().forEach(function (p) {
      var it = { id: p.id, quantity: p.quantity };
      if (p.properties) { it.properties = p.properties; }
      items.push(it);
    });
    return reihe(function () {
      return einmalWiederholen(function () { return schicken('/cart/add.js?_fd=0', { items: items }); }, true);
    }).then(function (antwort) {
      var zeilen = (antwort && antwort.items) || [];
      var ergebnis = { ok: true, pfand: pfandMenge, antwort: antwort,
        items: zeilen.filter(function (z) { return z.variant_id !== R.VID; }) };
      try { document.dispatchEvent(new CustomEvent('ft:warenkorb', { detail: ergebnis })); } catch (e) { /* alter Browser */ }
      if (pfandMenge > 0 && optionen.pruefen !== false && typeof window.ftPfandPruefen === 'function') {
        return window.ftPfandPruefen({ leise: true }).then(function () { return ergebnis; }, function () { return ergebnis; });
      }
      return ergebnis;
    }, function (f) {
      var fehler = { ok: false, status: (f && f.status) || 0, fehler: (f && f.fehler) || 'Unbekannter Fehler' };
      window.ftKorbFehlerMelden(optionen.weg || 'einlegen', { status: fehler.status, fehler: fehler.fehler, mitPfand: pfandMenge > 0 });
      /* Bei 422 legt Shopify teils die vorrätige Menge trotzdem ein (Messung der Sitzung Marketing, T7), bei Zeitüberschreitung
         ist offen, ob eingelegt wurde (status 0). In beiden Fällen leise abgleichen, damit das Pfand zum tatsächlichen Korb passt. */
      if (pfandMenge > 0 && (fehler.status === 422 || fehler.status === 0) && typeof window.ftPfandPruefen === 'function') {
        return window.ftPfandPruefen({ leise: true }).then(function () { return fehler; }, function () { return fehler; });
      }
      return fehler;
    });
  };

  /* Ein Fehlertext für alle Wege, in Sie-Form (Shopify meldet in Du-Form; Texte nach Durchgang Marketing Nr. 17).
     status 0 heißt: offen, ob eingelegt wurde, deshalb „prüfen“ statt „nochmal“, sonst legt man doppelt ein. */
  window.ftKorbFehlerText = function (e) {
    var t = String((e && e.fehler) || '');
    if (e && e.status === 0) { return 'Die Verbindung war kurz weg. Bitte prüfen Sie den Warenkorb.'; }
    if (/ausverkauft|sold out|nicht verfügbar|nicht mehr verfügbar/i.test(t)) { return 'Dieser Artikel ist gerade nicht auf Lager.'; }
    var n = t.match(/(\d+)/);
    if (e && e.status === 422 && n && /nur|only|alle|all /i.test(t)) {
      return 'Nur ' + n[1] + ' Stück auf Lager. Wir haben ' + n[1] + ' Stück in den Warenkorb gelegt.';
    }
    return 'Das hat leider nicht geklappt. Bitte noch einmal versuchen oder per WhatsApp melden.';
  };

  /* Menge einer Warenkorbzeile ändern (0 = entfernen), Pfand im selben Aufruf mitziehen. */
  window.ftKorbMenge = function (schluessel, menge) {
    var R = regel();
    menge = Math.max(0, parseInt(menge, 10) || 0);
    return reihe(function () {
      return einmalWiederholen(function () { return schicken('/cart.js?_fd=0', null, 'GET'); }).then(function (korb) {
        var updates = {};
        var soll = 0;
        var pfandZeilen = [];
        (korb.items || []).forEach(function (z) {
          if (z.variant_id === R.VID) { pfandZeilen.push(z.key); return; }
          var neu = (z.key === schluessel) ? menge : z.quantity;
          if (R.RX.test(String(z.sku || ''))) { soll += neu; }
        });
        updates[schluessel] = menge;
        if (pfandZeilen.length) {
          pfandZeilen.forEach(function (k, i) { updates[k] = (i === 0) ? soll : 0; });
        } else if (soll > 0 && R.VID) {
          /* Keine Pfand-Zeile im Korb (alter Korb): über die Varianten-ID im selben Aufruf anlegen. Shopify setzt dabei keine
             Zeilen-Eigenschaft; das ist nur der Hinweistext an der Kasse, die Menge zählt. */
          updates[R.VID] = soll;
        }
        return einmalWiederholen(function () { return schicken('/cart/update.js?_fd=0', { updates: updates }); });
      });
    }).then(function (korb) {
      return { ok: true, korb: korb };
    }, function (f) {
      var fehler = { ok: false, status: (f && f.status) || 0, fehler: (f && f.fehler) || 'Unbekannter Fehler' };
      window.ftKorbFehlerMelden('menge', { status: fehler.status, fehler: fehler.fehler });
      return fehler;
    });
  };
})();
